
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { MARKETING_MATURE } from '@src/view/components/viewer/data';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { isRefererCheck } from '@src/lib/utils/utils';
import React from 'react';
import { getComicData, getViewSignedCookies } from '@src/server/comicData';
import Seo, { GoogleSearchData } from '@src/seo/Seo';
import { CompanyInfo } from '@src/constants';
//import { UserSession } from '@src/lib/user/UserSession';

const ViewerComponent = dynamic<any>(
  () => import('@src/view/components/viewer/ViewerComponent'),
  {
    ssr: false,
  },
);

const Index = (props: any) => {
  const { comic, episode, data, isReferer } = props;

  return (
    <>
      <Seo
        title={`${data.title} ｜ ${CompanyInfo.NAME_UPPER_CASE} - Daily Updated Popular Web comics`}
        description={data.description}
        canonical={`${process.env.REACT_APP_PUBLIC_URL}/content/${comic}/${episode}`}
        searchData={GoogleSearchData({
          title: data.title,
          url: `${process.env.REACT_APP_PUBLIC_URL}/content/${comic}/${episode}`,
          description: data.description,
          image: data.thumbnail17,
          author: data.author,
        })}
      />
      <ViewerComponent
        marketingMature={MARKETING_MATURE.UNSET}
        comicId={comic}
        episodeId={episode}
        isReferer={isReferer}
      />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  const { query } = context;
  const { comicId, episodeId } = query;
  const isReferer = isRefererCheck(context);
  const comic: number = Number(comicId);
  const episode: number = Number(episodeId);

  if (_.isNaN(comic) || _.isNaN(episode)) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  const ret = await TopcoPartner.setterSSR(context);
  if (ret) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  try {
    const data = await getComicData(comic, episode);
    //const userId = UserSession.getUserIdBySSR(context);
    //if (process.env.REACT_APP_ENVIRONMENT === 'production' && comicId == 100545 && episodeId == 103460 && userId === '5351331') {
      const viewSigned = await getViewSignedCookies({ comicId: comic, episodeId: episode });
      if (viewSigned !== null && viewSigned?.data?.signedCookies) {
        context.res.setHeader('Set-Cookie', [
          `CloudFront-Key-Pair-Id=${viewSigned?.data?.signedCookies['CloudFront-Key-Pair-Id']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
          `CloudFront-Policy=${viewSigned?.data?.signedCookies['CloudFront-Policy']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
          `CloudFront-Signature=${viewSigned?.data?.signedCookies['CloudFront-Signature']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
        ]);
      }
    //}

    return {
      props: {
        isReferer,
        comic,
        episode,
        data,
      },
    };
  } catch (err: any) {
    console.error(err);
  }
}

export default Index;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/content/[comicId]/[episodeId]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  